import { defineMessages } from "react-intl";

import {
	currentlySmokingMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/risks/smoking";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	smoking: {
		id: "ktx.form.smoking",
		defaultMessage: "Dohányzás"
	},
	currentlySmoking: {
		id: "ktx.form.smoking.currently_smoking",
		defaultMessage: "Aktuálisan dohányzik?"
	},
	cigarettesPerDay: {
		id: "ktx.form.smoking.cigarettes_per_day",
		defaultMessage: "Hány szálat szív el naponta?"
	},
	numberOfYears: {
		id: "ktx.form.smoking.number_of_years",
		defaultMessage: "Hány éve dohányzik?"
	},
	packYears: {
		id: "ktx.form.smoking.pack_years",
		defaultMessage: "Csomagév"
	}
});

const fields: { [key: string]: FieldData } = {
	currentlySmoking: {
		type: "field",
		path: ["currentlySmoking"],
		label: messages.currentlySmoking,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: currentlySmokingMessages }
		}
	},
	cigarettesPerDay: {
		type: "field",
		path: ["cigarettesPackYears", "cigarettesPerDay"],
		label: messages.cigarettesPerDay,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	numberOfYears: {
		type: "field",
		path: ["cigarettesPackYears", "numberOfYears"],
		label: messages.numberOfYears,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	packYears: {
		type: "field",
		path: ["cigarettesPackYears", "packYears"],
		label: messages.packYears,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number", disabled: true } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.currentlySmoking }] },
		{
			columns: [
				{ width: 4, field: fields.cigarettesPerDay },
				{ width: 4, field: fields.numberOfYears },
				{ width: 4, field: fields.packYears }
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_smoking",
	value: {
		schemaId: "smoking",
		title: messages.smoking,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
